// A period Buffy fills in, written the way this teacher writes theirs
// (2026-10-24, F-2): classes typed into this dialog read "1 · Algebra", so
// Buffy's "Period 3" becomes "3"; a teacher who types "Period 1" (or "P1")
// gets "Period 3" (or "P3"). With no periods to go by, Buffy's words stay.
const PERIOD_PARTS = /^(period\s*|per\.?\s*|p\.?\s*)?(\d{1,2}[a-z]?)$/i;
export default function periodLike(raw, classes = []) {
  const p = String(raw || '').trim();
  const m = PERIOD_PARTS.exec(p);
  if (!m) return p;
  const styles = new Map(); // how their periods start ('' = just the number) -> how many
  for (const c of classes || []) {
    const t = PERIOD_PARTS.exec(String(c?.period || '').trim());
    if (t) styles.set(t[1] || '', (styles.get(t[1] || '') || 0) + 1);
  }
  if (!styles.size) return p;
  const [prefix] = [...styles.entries()].sort((a, b) => b[1] - a[1])[0];
  return `${prefix}${m[2]}`;
}
